import React, { useCallback, useEffect, useMemo } from "react";
import { withTranslation } from 'react-i18next';
import styles from './ReviewSummaryView.module.scss'
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { render } from "@testing-library/react";

const MedavieCurrentAddressSummary = ({ t, i18n, setIsError }) => {
  const medavieDifferentAddress = useSelector((state) => state.app.currentAddress.medavieDifferentAddress);
  if (!medavieDifferentAddress) {
    return null
  }

  const { streetAddress, apartment, city, postalCode } = medavieDifferentAddress;
  return (
    <>
      {/* <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
        <div className="col" style={{ flexGrow: 1 }}>{streetAddress} {apartment ? `${t('review_summary.unit')} ${apartment}` : ''}</div>
      </div>

      <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
        <div className="col" style={{ flexGrow: 1 }}>{city}, {postalCode.toUpperCase()}</div>
      </div> */}
      <hr />

      <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
        <div className="col-xs-6"><strong>{t('current_address.street_address')}</strong></div>
        <div className="col-xs-6">{streetAddress}</div>
      </div>

      <hr />


      <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
        <div className="col-xs-6"><strong>{t('current_address.apartment')}</strong></div>
        <div className="col-xs-6">{apartment ? `${apartment}` : null}</div>
      </div>

      <hr />


      <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
        <div className="col-xs-6"><strong>{t('current_address.city')}</strong></div>
        <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{city}</div>
      </div>

      <hr />

      <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
        <div className="col-xs-6"><strong>{t('current_address.postal_code')}</strong></div>
        <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{postalCode.toUpperCase()}</div>
      </div>

      <hr />

    </>
  )
}

const CurrentAddressSummary = ({ t, i18n, setIsError }) => {
  const history = useHistory();
  const { apartment, city, postalCode, streetAddress } = useSelector((state) => state.app.currentAddress);
  const currentAddressSameMedavie = useSelector((state) => state.app.currentAddress.currentAddressSameMedavie);
  const { jointlyRegistered, nsHealthCard, registeredBusiness, driverLicence, registeredByName } = useSelector((state) => state.app.addressTypeChange)

  const isRMV = useMemo(() => {
    return driverLicence || registeredByName || jointlyRegistered || registeredBusiness
  }, [driverLicence, registeredByName, jointlyRegistered, registeredBusiness]);

  useEffect(() => {
    try {
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [apartment, city, postalCode, streetAddress, setIsError])

  const editCurrentAddressOnClick = () => {
    try {
      history.push(`/${i18n.language}${t('routes.current_address')}?isSummary=true`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const getIsAddressSameAsBlueCross = useCallback(() => {
    return currentAddressSameMedavie ?
      t('review_summary.current_address_same')
      : <MedavieCurrentAddressSummary t={t} i18n={i18n} setIsError={setIsError} />
  }, [currentAddressSameMedavie, i18n, setIsError, t]);

  const rowHeader = useMemo(() => {
    return isRMV ? t('review_summary.registry_motor_vehicles') : t('review_summary.medavie_blue_cross')
  }, [isRMV, t])




  return (
    <div className="row">
      <div className="col-xs-12 col-lg-8">
        <div className="col-xs-12">
          <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
            <div style={{ display: "flex", flexGrow: 1, justifyContent: "space-between", alignItems: "center" }}>
              <div className="col-xs-6">
                <h3>{t('review_summary.current_address')}</h3>
                <br></br>
              </div>
              <div className="col-xs-6">

                <a href="#" className={[styles['edit_button']].join(' ')}
                  onClick={editCurrentAddressOnClick}
                  value={t(' jointly_owned_vehicle_summary.edit')} name={t('jointly_owned_vehicle_summary.edit')}>
                  {t('jointly_owned_vehicle_summary.edit')}
                </a>
              </div>
            </div>
          </div>


          <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
            <div className="col-xs-6" style={{ lineBreak: "anywhere" }}><strong>{rowHeader}</strong></div>
          </div>
          <hr />



          <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
            <div className="col-xs-6"><strong>{t('current_address.street_address')}</strong></div>
            <div className="col-xs-6">{streetAddress}</div>
          </div>

          <hr />


          <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
            <div className="col-xs-6"><strong>{t('current_address.apartment')}</strong></div>
            <div className="col-xs-6">{apartment ? `${apartment}` : null}</div>
          </div>

          <hr />


          <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
            <div className="col-xs-6"><strong>{t('current_address.city')}</strong></div>
            <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{city}</div>
          </div>

          <hr />

          <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
            <div className="col-xs-6"><strong>{t('current_address.postal_code')}</strong></div>
            <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{postalCode.toUpperCase()}</div>
          </div>

          <hr />



          {nsHealthCard && (driverLicence || registeredByName) && (

            <>
              <br></br>
              <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                <div className="col-xs-12"><strong>{t('review_summary.medavie_blue_cross')}</strong></div>
                <div className="col-xs-12" style={{ lineBreak: "anywhere" }}>{getIsAddressSameAsBlueCross()}</div>
              </div>
            </>

          )

          }
        </div>
      </div>
    </div>

    //division
    // <div className="row">
    //   <div className="col-xs-12 col-lg-8" >
    //     <div className="row">
    //       <h2 className="d-flex">{t('review_summary.current_address')}</h2>
    //       <a
    //         href="#"
    //         className={[styles['edit_button']].join(' ')}
    //         onClick={editCurrentAddressOnClick}
    //         value={t('jointly_owned_vehicle_summary.edit')}
    //         name={t('jointly_owned_vehicle_summary.edit')}
    //       >
    //         {t('jointly_owned_vehicle_summary.edit')}
    //       </a>
    //     </div>

    //     {/* <div className="col" style={{ display: 'flex', marginTop: "1rem", justifyContent: "flex-end", alignItems: "center" }}>

    //       <a
    //         href="#"
    //         className={[styles['edit_button']].join(' ')}
    //         onClick={editCurrentAddressOnClick}
    //         value={t('jointly_owned_vehicle_summary.edit')}
    //         name={t('jointly_owned_vehicle_summary.edit')}
    //       >
    //         {t('jointly_owned_vehicle_summary.edit')}
    //       </a>

    //     </div> */}

    //     {/* {(driverLicence || registeredByName) && ( */}
    //     <>
    //       <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
    //         <div className="col" style={{ flexGrow: 1, backgroundColor: "lightgray" }}><strong>{rowHeader}</strong></div>
    //       </div>
    //       <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
    //         <div className="col" style={{ flexGrow: 1 }}>{streetAddress} {apartment ? `${t('review_summary.unit')} ${apartment}` : ''}</div>
    //       </div>

    //       <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
    //         <div className="col" style={{ flexGrow: 1 }}>{city}, {postalCode.toUpperCase()}</div>
    //       </div>
    //     </>
    //     {/* )} */}



    //     {nsHealthCard && (driverLicence || registeredByName) && (
    //       <>
    //         <div className="row" style={{ display: 'flex', flexGrow: 1, marginTop: "1rem" }}>
    //           <div className="col" style={{ flexGrow: 1, backgroundColor: "lightgray" }}><strong>{t('review_summary.medavie_blue_cross')}</strong></div>
    //         </div>
    //         < div className="row" style={{ display: 'flex', flexGrow: 1, }}>
    //           <div className="col" style={{ flexGrow: 1 }}>{getIsAddressSameAsBlueCross()}</div>
    //         </div>
    //       </>
    //     )

    //     }



    //   </div>
    // </div >
  )
}

export default withTranslation('common')(CurrentAddressSummary)
